import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ae49f3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("head", null, [
  /*#__PURE__*/_createElementVNode("title", null, "Recherche | RACA")
], -1))
const _hoisted_2 = { class: "grid-main-et-marges" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "marge" }, null, -1))
const _hoisted_4 = {
  class: "filtres",
  ref: "panneauLateral"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "conteneur-bouton-recherche" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "bouton-recherche" }, "Rechercher")
], -1))
const _hoisted_7 = { class: "conteneur-sous-barre-recherche" }
const _hoisted_8 = { class: "conteneur-etiquettes" }
const _hoisted_9 = { class: "libelle-etiquette" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "carte-avec-marge-interieure" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "grille-coordonnees" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["href", "title"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["href", "title"]
const _hoisted_19 = { key: 2 }
const _hoisted_20 = ["href", "title"]
const _hoisted_21 = { key: 3 }
const _hoisted_22 = ["href", "title"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "texte-gris" }
const _hoisted_25 = { class: "conteneur-exportation-et-navigation" }
const _hoisted_26 = { class: "exportation" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Exporter en CSV ")
const _hoisted_28 = {
  key: 0,
  class: "nav-pagination"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "marge" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FiltresEntreprises = _resolveComponent("FiltresEntreprises")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_JsonCSV = _resolveComponent("JsonCSV")!
  const _component_ModalEntreprise = _resolveComponent("ModalEntreprise")!
  const _component_FooterPartner = _resolveComponent("FooterPartner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("main", null, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_FiltresEntreprises, { onFiltreChangement: _ctx.chargeListeEntreprises }, null, 8, ["onFiltreChangement"])
        ], 512),
        (_ctx.entreprisesPretes)
          ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("form", {
                  class: "conteneur-zone-rechercher",
                  onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.faisRecherche && _ctx.faisRecherche(...args)), ["prevent"]))
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "search",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.recherche) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.recherche]
                  ]),
                  _hoisted_6
                ], 32)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, _toDisplayString(_ctx.totalResultat === 0
                ? 'Aucun résultat à afficher'
                : `${_ctx.totalResultat} résultat(s)`), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtres, ([id, filtre]) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: id }, [
                    (filtre.estActif)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "etiquette",
                          ref_for: true,
                          ref: filtre.nom
                        }, [
                          _createElementVNode("span", _hoisted_9, _toDisplayString(filtre.nom), 1),
                          _createElementVNode("span", {
                            class: "fermeture-etiquette",
                            onClick: ($event: any) => (_ctx.removeFiltre(filtre))
                          }, "x", 8, _hoisted_10)
                        ], 512))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                _withDirectives(_createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.reinitialiseFiltres && _ctx.reinitialiseFiltres(...args))),
                  class: "bouton-reinitialisation"
                }, " Effacer les filtres ", 512), [
                  [_vShow, _ctx.getNbOfFiltresActif() > 0]
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listeEntreprisesAffiche, (entreprise) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "card",
                  key: entreprise.id
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("h3", null, [
                      _createTextVNode(_toDisplayString(entreprise.nom), 1),
                      _createElementVNode("button", {
                        class: "show-more",
                        onClick: ($event: any) => (_ctx.openModalEntreprise(entreprise))
                      }, " Afficher plus ", 8, _hoisted_12)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h4", null, _toDisplayString(entreprise.nomContact), 1),
                          _createElementVNode("div", null, [
                            _createElementVNode("a", {
                              href: `mailto:${entreprise.courriel}`
                            }, _toDisplayString(entreprise.courriel), 9, _hoisted_14)
                          ]),
                          (entreprise.facebook)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createVNode(_component_font_awesome_icon, { icon: ['fab', 'facebook'] }),
                                _createElementVNode("a", {
                                  href: entreprise.facebook,
                                  title: `Page Facebook pour ${entreprise.nom}`
                                }, "Facebook", 8, _hoisted_16)
                              ]))
                            : _createCommentVNode("", true),
                          (entreprise.twitter)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createVNode(_component_font_awesome_icon, { icon: ['fab', 'twitter'] }),
                                _createElementVNode("a", {
                                  href: entreprise.twitter,
                                  title: `Twitter pour ${entreprise.nom}`
                                }, "Twitter", 8, _hoisted_18)
                              ]))
                            : _createCommentVNode("", true),
                          (entreprise.instagram)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createVNode(_component_font_awesome_icon, { icon: ['fab', 'instagram'] }),
                                _createElementVNode("a", {
                                  href: entreprise.instagram,
                                  title: `Instagram pour ${entreprise.nom}`
                                }, "Instagram", 8, _hoisted_20)
                              ]))
                            : _createCommentVNode("", true),
                          (entreprise.siteWeb)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("a", {
                                  class: "site-web",
                                  href: entreprise.siteWeb,
                                  title: `Site pour ${entreprise.nom}`
                                }, _toDisplayString(entreprise.siteWeb), 9, _hoisted_22)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", null, _toDisplayString(entreprise.adresse), 1),
                          (entreprise.ville)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(entreprise.ville.nom), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", null, _toDisplayString(entreprise.codePostal), 1)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entreprise.entreprise_produits, (entreprise_produit) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: entreprise_produit.id
                              }, [
                                _createTextVNode(_toDisplayString(entreprise_produit.produit.nom) + " ", 1),
                                (entreprise_produit.type_transaction)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      style: _normalizeStyle({
                          color: entreprise_produit.type_transaction.color
                            ? entreprise_produit.type_transaction.color
                            : 'inherit',
                        })
                                    }, " (" + _toDisplayString(entreprise_produit.type_transaction.nom) + ")", 5))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_JsonCSV, {
                  data: _ctx.getListeEntreprisesToExport(),
                  name: "Entreprises.csv",
                  delimiter: ";"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("button", _hoisted_26, [
                      _createVNode(_component_font_awesome_icon, { icon: ['far', 'file-export'] }),
                      _hoisted_27
                    ], 512), [
                      [_vShow, _ctx.listeEntreprisesAffiche.length > 0]
                    ])
                  ]),
                  _: 1
                }, 8, ["data"]),
                (_ctx.totalResultat !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      (_ctx.indexPage > 0)
                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 0,
                            icon: ['fas', 'caret-left'],
                            class: "logo-fleche",
                            onClick: _ctx.previousPage,
                            id: "fleche-gauche"
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createTextVNode(" Page " + _toDisplayString(_ctx.indexPage + 1) + " de " + _toDisplayString(_ctx.numberOfPages) + " ", 1),
                      (_ctx.indexPage < _ctx.numberOfPages - 1)
                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 1,
                            icon: ['fas', 'caret-right'],
                            class: "logo-fleche",
                            onClick: _ctx.nextPage,
                            id: "fleche-droite"
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _withDirectives(_createVNode(_component_ModalEntreprise, {
                  onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModal = false)),
                  ref: "modalEntreprise"
                }, null, 512), [
                  [_vShow, _ctx.showModal]
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_29
    ]),
    _createVNode(_component_FooterPartner)
  ], 64))
}